import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isOnline } from 'utils';
import LandingPageIcon from '../../../public/landing-page-icon.svg';
import './landing-page.scss';
import { envConfig } from 'config';

export const LandingPage: FC = () => {

    const config = envConfig();
    const [isAppOnline, setIsAppOnline] = useState<boolean>(navigator.onLine);
    const appVersion: string = process.env.REACT_APP_VERSION ?? ''
    const environment: string = config.REACT_APP_ENVIRONMENT ?? ''

    const navigate = useNavigate();

    const login = async () => {
        if (await isOnline()) {
            navigate('/load-assignments')
        }
        else {
            setIsAppOnline(false)
        }
    }

    useEffect(() => {
        const onlineCheckInterval = setInterval(async () => {
            setIsAppOnline(await isOnline())
        }, 10000)

        return () => clearInterval(onlineCheckInterval)
    }, [])

    return (
        <div className={'landing-page'}>
            <div className={'landing-page-content'}>
                <div className={'landing-page-content-welcome-container'}>
                    <div className={'landing-page-image'}>
                        <img src={LandingPageIcon} />
                    </div>
                    <div className={'landing-page-welcome'}> Welcome to Load Manager</div>
                </div>
                <div className={'landing-page-content-action-container'}>
                    {!isAppOnline &&
                        <div className={'landing-page-online'}>You need to be online to get started</div>
                    }
                    <div className={`landing-page-button-container${isAppOnline ? '' : '-disabled'}`} onClick={login}>
                        <div className={'landing-page-button'}> Get Started </div>
                    </div>
                    <div className={'landing-page-copyright'}>©2022, Dot Foods, Inc.</div>
                    <div className={'landing-page-version'}>{`Version ${appVersion}${environment ? ` (${environment})` : ''}`}</div>
                </div>
            </div>
        </div>
    )
};
